module.exports = __webpack_public_path__ + "static/media/HeaderRightArrow.5ea897d9.svg";